"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCircleClock = void 0;
var react_1 = __importDefault(require("react"));
var IconCircleClock = function (props) { return (react_1.default.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M12 24C18.6274 24 24 18.6278 24 12.0004C24 5.37303 18.6278 0.000431472 12.0004 0C5.37303 0 0.000431472 5.3726 0 12C0.00733546 18.6244 5.37562 23.9927 12 24ZM12 1.76742C17.6513 1.76742 22.2326 6.34908 22.2326 12.0004C22.2326 17.6518 17.6513 22.233 12 22.2326C6.34865 22.2326 1.76742 17.6513 1.76742 12C1.77389 6.35124 6.35167 1.77389 12 1.76742Z" }),
    react_1.default.createElement("path", { d: "M10.9617 14H16.0844C16.59 14 17 13.6187 17 13.1483C17 12.678 16.59 12.2966 16.0844 12.2966H11.8313V6.85169C11.8313 6.38093 11.4213 6 10.9156 6C10.41 6 10 6.38093 10 6.85169V13.1059C10.0183 13.5925 10.4381 13.9834 10.9617 14Z" }))); };
exports.IconCircleClock = IconCircleClock;
